import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { SiteTypeService } from '../../../Model/SiteType/site-type.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-site-type-form',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './site-type-form.component.html',
  styleUrl: './site-type-form.component.scss'
})
export class SiteTypeFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() id!: number;

  filter = {
    SelectType: 'S',
    SiteTypeMasterId: 0
  }

  Detail = {
    SelectType: 'Insert',
    SiteTypeMasterId: 0,
    SiteTypeName: null,
    UserId: null,
    Active: true
  }
  constructor(
    private modalService: NgbModal,
    private toast: ToastService,
    private combo: ComboService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private sitetype: SiteTypeService
  ) {
    this.common.getPageRights();
    // this.common.PageRight.IsAdd = true
    // this.common.PageRight.IsDelete = true
    // this.common.PageRight.IsEdit = true
    // this.common.PageRight.IsView = true
    // this.common.PageRight.IsPrint = true

    this.Detail.SiteTypeMasterId = this.id
    this.filter.SiteTypeMasterId = this.id
  }

  ngOnInit(): void {
    if (this.id > 0) {
      this.GetData();
    }
  }

  GetData() {
    this.isDisabled = true;
    this.filter.SiteTypeMasterId = this.id;
    this.sitetype.SiteTypeLoad(this.filter).subscribe({
      next: (response) => {
        this.Detail.SelectType = 'Update';
        this.Detail.SiteTypeName = response.Table[0].SiteTypeName;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

 async Save() {
     await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want save?'
    modalRef.result.then((result: any) => {
      if ((this.id == 0 && this.common.PageRight.IsAdd) || (this.id > 0 && this.common.PageRight.IsEdit)) {
        if (result) {
          this.isDisabled = true;
          this.Detail.SiteTypeMasterId = this.id
          this.sitetype.SiteTypeInsert(this.Detail).subscribe({
            next: (response) => {
              if (response.Error_Code == '637' || response.Error_Code == '636') {
                this.activeModal.close(true);
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
              }
              else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => { this.isDisabled = false; },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  close() {
    this.activeModal.close();
  }
}
